var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_content" },
    [
      _c("ConfirmDeleteCategory", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisibleModalConfirmDelete,
            expression: "isVisibleModalConfirmDelete"
          }
        ],
        on: {
          close: _vm.closeModalConfirmDelete,
          delete: _vm.confirmDeleteCategory
        }
      }),
      _c("ConfirmDeleteItem", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisibleModalConfirmDeleteItem,
            expression: "isVisibleModalConfirmDeleteItem"
          }
        ],
        on: {
          close: _vm.closeModalConfirmDeleteItem,
          delete: function($event) {
            return _vm.confirmDeleteItem(_vm.categoryIndex, _vm.itemIndex)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "setting_content_main" },
        [
          _c("div", { staticClass: "setting_content_heading" }, [
            _c("h2", { staticClass: "setting_content_title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.screenLabelsProperties.TAB_HEADER) +
                  "\n      "
              )
            ]),
            _c(
              "div",
              { staticClass: "setting_content_heading_btn ml-3" },
              [
                _c(
                  "button",
                  {
                    staticClass: "setting_btn_secondary setting_btn_medium",
                    on: { click: _vm.openPopupAddCategory }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.screenLabelsProperties.ADD_CATEGORY_BUTTON) +
                        "\n        "
                    )
                  ]
                ),
                _c("ModalCategory", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isVisibleModalCategory,
                      expression: "isVisibleModalCategory"
                    }
                  ],
                  attrs: { category: _vm.category },
                  on: {
                    close: _vm.closeModalCategory,
                    submit: function($event) {
                      return _vm.addCategory()
                    }
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "setting_category_header" }, [
            _c("div", { staticClass: "setting_category_header_sorting" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.screenLabelsProperties.SORT_FIELD) +
                  "\n      "
              )
            ]),
            _c("div", { staticClass: "setting_category_header_display" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.screenLabelsProperties.DISPLAY_FIELD) +
                  "\n      "
              )
            ]),
            _c("div", { staticClass: "setting_category_header_content" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.screenLabelsProperties.ITEM_NAME_FIELD) +
                  "\n      "
              )
            ]),
            _c(
              "div",
              { staticClass: "setting_category_header_operation_wide" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.screenLabelsProperties.OPTION_FIELD) +
                    "\n      "
                )
              ]
            )
          ]),
          _c(
            "draggable",
            _vm._b(
              {
                staticClass: "setting_category",
                attrs: { list: _vm.categories, handle: ".handle" },
                on: { change: _vm.updateDisplay, sort: _vm.updateCategory }
              },
              "draggable",
              { disabled: false },
              false
            ),
            _vm._l(_vm.categories, function(subCategory, index) {
              return _c(
                "div",
                { key: index, staticClass: "setting_category_wrapper" },
                [
                  subCategory && !subCategory.categoryDeleted
                    ? _c("div", { staticClass: "setting_category_item" }, [
                        _c(
                          "div",
                          { staticClass: "setting_category_item_sorting" },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "setting_category_item_sorting_icon handle evt-click",
                                attrs: {
                                  width: "10",
                                  height: "12",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      fill: "#aaa",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "setting_category_item_display" },
                          [
                            !subCategory.isCollapse
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "setting_category_item_display_arrow evt-click",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.changeCollapse(index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "6",
                                          height: "6",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M3 0l3 6H0z",
                                            fill: "#333",
                                            "fill-rule": "evenodd"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "setting_category_item_display_arrow is_open evt-click",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.changeCollapse(index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "6",
                                          height: "6",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M3 0l3 6H0z",
                                            fill: "#333",
                                            "fill-rule": "evenodd"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "setting_category_item_content setting_word_break"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(subCategory.categoryName) +
                                "\n          "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "setting_category_item_operation" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "setting_category_item_operation_add"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "setting_category_item_operation_add_btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.openAddItemModal(index, -1)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.screenLabelsProperties
                                            .ADD_ITEM_LINK
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm.isVisibleModalItems[index] &&
                                _vm.isVisibleModalItems[index].status
                                  ? _c("AddItem", {
                                      attrs: {
                                        item: _vm.item,
                                        availableResource:
                                          _vm.availableResource,
                                        resourceFields: _vm.resourceFields
                                      },
                                      on: {
                                        updateResourceFields:
                                          _vm.updateResourceFields,
                                        close: function($event) {
                                          return _vm.closeAddItemModal(
                                            index,
                                            -1
                                          )
                                        },
                                        submit: function($event) {
                                          return _vm.addItemToCategory(
                                            _vm.categoryIndex,
                                            _vm.itemIndex
                                          )
                                        },
                                        updateFirstResourceCategory:
                                          _vm.updateFirstResourceCategory,
                                        resetFirstResourceCategory: function(
                                          $event
                                        ) {
                                          return _vm.resetFirstResourceCategory(
                                            index
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "setting_category_item_operation_edit"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "setting_btn_secondary setting_btn_medium",
                                    on: {
                                      click: function($event) {
                                        return _vm.openPopUpEditCategory(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.screenLabelsProperties
                                            .EDIT_ITEM_BUTTON
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _c("ModalCategory", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.isVisibleEditModalCategories[index],
                                      expression:
                                        "isVisibleEditModalCategories[index]"
                                    }
                                  ],
                                  attrs: { category: _vm.category },
                                  on: {
                                    close: function($event) {
                                      return _vm.closeModalEditCategory(index)
                                    },
                                    submit: function($event) {
                                      return _vm.editCategory(index)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "setting_btn_delete setting_btn_medium",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteCategory(index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.screenLabelsProperties
                                        .DELETE_ITEM_BUTTON
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  subCategory && !subCategory.categoryDeleted
                    ? _c(
                        "div",
                        [
                          subCategory.isCollapse
                            ? _c(
                                "draggable",
                                {
                                  attrs: {
                                    list: subCategory.item,
                                    handle: ".handle"
                                  },
                                  on: {
                                    change: _vm.logChangeData,
                                    sort: _vm.updateCategory
                                  }
                                },
                                _vm._l(subCategory.item, function(
                                  resource,
                                  subIndex
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: subIndex,
                                      staticClass: "align-items-center"
                                    },
                                    [
                                      resource.itemDeleted === undefined ||
                                      !resource.itemDeleted
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "setting_column_item",
                                                class: resource.isDeletedByMainSystem
                                                  ? "item-deleted-setting"
                                                  : "",
                                                attrs: {
                                                  title: resource.isDeletedByMainSystem
                                                    ? _vm
                                                        .screenMessagesProperties
                                                        .ITEM_DELETED_BY_MATCHINGGOOD2ND
                                                    : ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_column_item_sorting handle evt-click"
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "setting_column_item_sorting_icon",
                                                        attrs: {
                                                          width: "10",
                                                          height: "12",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "g",
                                                          {
                                                            attrs: {
                                                              fill: "#aaa",
                                                              "fill-rule":
                                                                "evenodd"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d:
                                                                  "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_column_item_content setting_word_break"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          resource.itemName
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_column_item_operation"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "setting_column_item_operation_add"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "setting_btn_secondary setting_btn_medium",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openAddItemModal(
                                                                  index,
                                                                  subIndex
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm
                                                                    .screenLabelsProperties
                                                                    .EDIT_ITEM_BUTTON
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _c("AddItem", {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm
                                                                  .isVisibleModalItems[
                                                                  index
                                                                ] &&
                                                                _vm
                                                                  .isVisibleModalItems[
                                                                  index
                                                                ].subModal[
                                                                  subIndex
                                                                ],
                                                              expression:
                                                                "isVisibleModalItems[index] && isVisibleModalItems[index].subModal[subIndex]"
                                                            }
                                                          ],
                                                          ref: "addItemRef",
                                                          refInFor: true,
                                                          attrs: {
                                                            item: _vm.item,
                                                            availableResource:
                                                              _vm.availableResource,
                                                            resourceFields:
                                                              _vm.resourceFields
                                                          },
                                                          on: {
                                                            updateResourceFields:
                                                              _vm.updateResourceFields,
                                                            close: function(
                                                              $event
                                                            ) {
                                                              return _vm.closeAddItemModal(
                                                                index,
                                                                subIndex
                                                              )
                                                            },
                                                            submit: function(
                                                              $event
                                                            ) {
                                                              return _vm.addItemToCategory(
                                                                _vm.categoryIndex,
                                                                _vm.itemIndex
                                                              )
                                                            },
                                                            updateFirstResourceCategory:
                                                              _vm.updateFirstResourceCategory,
                                                            resetFirstResourceCategory: function(
                                                              $event
                                                            ) {
                                                              return _vm.resetFirstResourceCategory(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "setting_btn_delete setting_btn_medium",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteItem(
                                                              index,
                                                              subIndex
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm
                                                                .screenLabelsProperties
                                                                .DELETE_ITEM_BUTTON
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "setting_content_sub",
            attrs: { id: "menu-search-item-screen-tab" }
          },
          [
            _c("div", { attrs: { id: "heading_search_item" } }, [
              _c(
                "div",
                {
                  staticClass:
                    "setting_options_search d-flex justify-content-end"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "setting_btn_secondary setting_btn_medium",
                      on: { click: _vm.refreshResourceList }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.screenLabelsProperties.REFRESH_RESOURCE_BUTTON
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "setting_options_search setting_options_search_customize"
                },
                [
                  _c("p", { staticClass: "setting_options_search_label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.screenLabelsProperties.SEARCH_LABEL) +
                        "\n          "
                    )
                  ]),
                  _c("div", { staticClass: "setting_options_search_box" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.computedProperty,
                          expression: "computedProperty"
                        }
                      ],
                      staticClass: "setting_form_text",
                      attrs: {
                        type: "text",
                        placeholder: [
                          [_vm.screenLabelsProperties.SEARCH_PLACEHOLDER]
                        ]
                      },
                      domProps: { value: _vm.computedProperty },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.getResourceFields($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.computedProperty = $event.target.value
                        }
                      }
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "setting_btn_primary",
                        on: { click: _vm.getResourceFields }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "16",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: { fill: "none", "fill-rule": "evenodd" }
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    stroke: "#FFF",
                                    "stroke-width": "2",
                                    cx: "6.5",
                                    cy: "6.5",
                                    r: "5.5"
                                  }
                                }),
                                _c("path", {
                                  attrs: {
                                    fill: "#FFF",
                                    d:
                                      "M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]),
            _c(
              "div",
              {
                staticClass: "setting_options_wrapper",
                attrs: { id: "item_resource_wrapper" }
              },
              [
                _c(
                  "div",
                  { staticClass: "setting_options_category" },
                  _vm._l(_vm.candidateCategories, function(
                    candidateCategory,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _vm.checkEmptyResourceCategory(
                          candidateCategory.name
                        ) && candidateCategory.is_display === 1
                          ? [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "setting_options_category_name candidates mt-3"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(candidateCategory.display_name) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _c(
                                "draggable",
                                {
                                  attrs: {
                                    group: {
                                      name: "item-category",
                                      put: false,
                                      pull: "clone"
                                    },
                                    sort: false,
                                    clone: _vm.cloneResource,
                                    list: _vm.computedResourceFields
                                  }
                                },
                                _vm._l(_vm.computedResourceFields, function(
                                  resourceField,
                                  index
                                ) {
                                  return _c("div", { key: index }, [
                                    resourceField.property_category_name ===
                                      candidateCategory.name &&
                                    !resourceField.isUsed
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "setting_options_category_item",
                                            class:
                                              resourceField &&
                                              resourceField.required === 1
                                                ? "item_required"
                                                : "",
                                            attrs: {
                                              title:
                                                resourceField &&
                                                resourceField.required === 1
                                                  ? resourceField.display_name +
                                                    _vm.screenMessagesProperties
                                                      .ITEM_REQUIRE_SETTING
                                                  : ""
                                            },
                                            on: {
                                              mousedown: function($event) {
                                                return _vm.checkAvailableResourceDragging(
                                                  resourceField.property_category_name
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "setting_options_category_item_icon",
                                                attrs: {
                                                  width: "10",
                                                  height: "12",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      fill: "#aaa",
                                                      "fill-rule": "evenodd"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c("span", {
                                              staticClass:
                                                "setting_options_category_item_name",
                                              domProps: {
                                                textContent: _vm._s(
                                                  resourceField.display_name
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                }),
                                0
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }